import React, { useEffect, useRef, useState } from 'react';
import ApexCharts from 'apexcharts';
import TauriSectionModalVisual from '../TauriSectionBaseVisual/TauriSectionModalVisual/TauriSectionModalVisual';
import TauriSectionModalMultiVisual from '../TauriSectionBaseVisual/TauriSectionModalMultiVisual/TauriSectionModalMultiVisual';
import setting from '../../config.json';

const TauriBarVisual = ({ chartConfig, chartData, chartOptions, columnSize, rowSize, palettes, themes, chartPalettes }) => {
    const chartRef = useRef(null);
    const [selectedVisual, setSelectedVisual] = useState(null);
    const [selectedData, setSelectedData] = useState(null);
    const [modalPosition, setModalPosition] = useState({ x: 0, y: 0 });

    useEffect(() => {
        if (!chartData) return;

        const handleDataPointSelection = (event, chartContext, config) => {
            const selectedSliceIndex = config.dataPointIndex;
            const title = chartConfig.binding.context.point.onClick.selectedValueColumn;
            const modalTitle = chartConfig.binding.context.point.onClick.selectedTitle;
            const selectedDesc = chartData[selectedSliceIndex][chartConfig.binding.data.title];
            const selectedVal = chartData[selectedSliceIndex][title];
            const selectedTitle = chartConfig.title;

            if (chartConfig.binding.context.point.onClick.visual || Array.isArray(chartConfig.binding.context.point.onClick.visuals)) {
                let selectedVisual = null;
                if (chartConfig.binding.context.point.onClick.visuals) {
                    // Handle multiple visuals
                    const selectedSliceVisualIndex = config.dataPointIndex;
                    selectedVisual = chartConfig.binding.context.point.onClick.visuals;
                } else {
                    // Handle single visual
                    selectedVisual = chartConfig.binding.context.point.onClick.visual;
                }

                setSelectedVisual(selectedVisual);
                setSelectedData({ title, selectedDesc, selectedVal, selectedTitle, modalTitle });

                const tauriElement = document.querySelector('.tauri-host-container');
                if (tauriElement) {
                    if (event) {
                        const { left, top, right, bottom } = tauriElement.getBoundingClientRect();
                        let posX = event.clientX;
                        let posY = event.clientY;
                        if ((event.clientX + setting.modalMinWidth) > window.innerWidth) {
                            posX = event.clientX - setting.modalMinWidth;
                        }
                        if ((event.clientY + setting.modalMinHeight) > window.innerHeight) {
                            posY = event.clientY - setting.modalMinHeight;
                        }

                        setModalPosition({ x: posX, y: posY });
                    }
                }
            }
        };

        const formatNumber = (value) => {
            if (Math.abs(value) >= 1.0e+9) {
                return (value / 1.0e+9).toFixed(1) + 'B'; // Billions
            }
            if (Math.abs(value) >= 1.0e+6) {
                return (value / 1.0e+6).toFixed(1) + 'M'; // Millions
            }
            if (Math.abs(value) >= 1.0e+3) {
                return (value / 1.0e+3).toFixed(1) + 'K'; // Thousands
            }
            return value.toLocaleString(); // Default formatting
        };


        const series = chartConfig.binding.data.series.map((seriesItem, index) => ({
            name: seriesItem?.name,
            data: chartData?.map(item => item[seriesItem?.value] ?? null),
            //color: chartPalettes[index].ranges
            color: chartPalettes[index]?.ranges?.[0] ?? null,
        }));

        const options = {
            chart: {
                ...chartOptions.chart,
                toolbar: {
                    show: true,
                    tools: {
                        download: true
                    }
                },
                events: {
                    dataPointSelection: handleDataPointSelection,
                    mounted: function (chart) {
                        const labels = document.querySelectorAll('.apexcharts-xaxis text tspan');
                        labels.forEach(label => {
                            label.style.fontFamily = 'Lato-Regular';
                            label.style.setProperty('font-family', 'Lato-Regular', 'important');
                        });
                    }
                }
            },
            tooltip: chartOptions.tooltip,
            xaxis: {
                ...chartOptions.xaxis,
                categories: chartData?.map(item => item[chartConfig?.binding?.data?.title] || ''),
                title: {
                    ...chartOptions.xaxis.title,
                    text: chartConfig.xAxis
                },
                labels: {
                    formatter: (value) => {
                        return isNaN(value) ? value : formatNumber(value);
                    },
                    style: {
                        fontFamily: 'Calibri',
                    }
                },
            },
            yaxis: {
                ...chartOptions.yaxis,
                title: {
                    ...chartOptions.yaxis.title,
                    text: chartConfig.yAxis
                }
            },
            //colors: chartPalettes.map(item => item.ranges),
            //colors: chartPalettes.flatMap(item => item.ranges),
            series,
            grid: chartOptions.grid,
            legend: chartOptions.legend,
            dataLabels: chartOptions.dataLabels,
            plotOptions: {
                bar: {
                    ...chartOptions.plotOptions.bar,

                    horizontal: chartConfig.orientation === 'horizontal',
                }
            },
            stroke: chartOptions.stroke
        };

        const chart = new ApexCharts(chartRef.current, options);

        chart.render();

        return () => {
            chart.destroy();
        };
    }, [chartConfig, chartData]);

    return (
        <>
            <div className='chart-content'>
                <div ref={chartRef} />
            </div>
            {selectedVisual && (
                chartConfig.binding.context.point.onClick.visuals ? (
                    <TauriSectionModalMultiVisual
                        show={selectedVisual !== null}
                        onHide={() => setSelectedVisual(null)}
                        selectedData={selectedData}
                        visual={selectedVisual}
                        columnSize={columnSize}
                        rowSize={rowSize}
                        style={{ top: modalPosition.y, left: modalPosition.x }}
                        palettes={palettes}
                        themes={themes}
                    />
                ) : (
                    <TauriSectionModalVisual
                        show={selectedVisual !== null}
                        onHide={() => setSelectedVisual(null)}
                        selectedData={selectedData}
                        visual={selectedVisual}
                        columnSize={columnSize}
                        rowSize={rowSize}
                        style={{ top: modalPosition.y, left: modalPosition.x }}
                        palettes={palettes}
                        themes={themes}
                    />
                )
            )}
        </>
    );
};

export default TauriBarVisual;
